import React, {useEffect} from 'react';
import {PrimaryButton} from "../../components/Buttons.jsx";

const Cartwheel = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Page header */}
      <div className="sm:flex sm:justify-between sm:items-center mb-8">
        {/* Left: Title */}
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
            Dispatch 
          </h1>
        </div>
      </div>
      <PrimaryButton
        onClick={() => {
          window.open('https://saucey.cartwheel.tech/app/#login?redirectTo=dispatcher-map')
        }}
      >
        Launch Dispatch Application
      </PrimaryButton>
    </div>
  )
  // return (
  //   <iframe width='100%' height='100%' src='https://saucey.cartwheel.tech/app/#login?redirectTo=dispatcher-map'>
  //   </iframe>
  // )
}

export default Cartwheel;